// Ce fichier sert uniquement de pont pour ne pas casser les imports existants
import FuelView from './fuel/FuelView';
export default FuelView;